import {FaInstagram, FaGooglePlay, FaApple} from 'react-icons/fa'

function SocialMedia() {

    return (
        <nav>
            <div className="content-one">
                <div className="social-midia">
                    <a target='_blank' href='https://www.instagram.com/ecellacessorios' rel="noreferrer"><FaInstagram size={20} color='#f0f0f0'/></a>
                    <a target='_blank' href='https://www.instagram.com/ecellshopbarber' rel="noreferrer"><FaInstagram size={20} color='#f0f0f0'/></a>
                    <a target='_blank' href='https://play.google.com/store/apps/details?id=br.inf.ecell.ecellacess&pcampaignid=web_share' rel="noreferrer"><FaGooglePlay size={19} color='#f0f0f0'/></a>
                    <a target='_blank' href='https://apps.apple.com/app/id1531213629' rel="noreferrer"><FaApple size={20} color='#f0f0f0'/></a>
                </div>
            </div>
        </nav>
    )
}

export default SocialMedia
